import * as React from 'react'
import { Grid2 } from '@mui/material'
import Navbar from '../setup/Navbar'
import HeadingText from '../../BuiltInComponent/HeadingTest'
import TextFields from '../../BuiltInComponent/TextField'
import ButtonNormal from '../../BuiltInComponent/ButtonNormal'
import { useDispatch, useSelector } from 'react-redux'
import { addNewItem, getAllICategories, deleteCategory } from '../../features/GeneralManagement/itemCategorySlice'
import StickyHeadTable from '../../BuiltInComponent/TableWithPagination'
import Loading from '../../BuiltInComponent/Loading'

export default function ItemCategory() {

    const dispatch = useDispatch()

    const { categories, isLoading } = useSelector((state) => state.ic)

    React.useEffect(() => {
        dispatch(getAllICategories())
    }, [dispatch])
    const [itemCategory, setItemCategory] = React.useState({
        cateDescription: ''
    })

    const onChange = (data) => {
        const keys = Object.keys(data)
        setItemCategory(prevData => ({
            ...prevData,
            [keys[0]]: data[keys[0]]
        }))
    }

    const onClick = async () => {

        await dispatch(addNewItem(itemCategory))
            .then(() => {
                dispatch(getAllICategories())
            })
    }

    const tableColumns = [
        { fieldName: 'cateCode', cName: 'Item Code', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'cateDescription', cName: 'Description', textAlign: 'left', width: 300, status: 'en', dType: 'string' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'right', width: 20, status: 'dis', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 20, status: 'en', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'right', width: 80, status: 'dis', dType: 'string' },
    ];

    const onEditClick = async (itemCode) => {

    }

    const onDeleteClick = async (itemCode) => {
        console.log(itemCode)
        await dispatch(deleteCategory({ itemCode: itemCode }))
            .then(() => {
                dispatch(getAllICategories())
            })

        // await dispatch(getAllItems())
    }
    return (
        <>
            <Navbar />
            <Grid2 container spacing={2} sx={{ padding: '20px' }}>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}><HeadingText text='Item Category' /></Grid2>
                <Grid2 size={4}></Grid2>

                <Grid2 size={4}></Grid2>
                <Grid2 size={4}>
                    {/* <TextField value={itemCategory.cateDescription} onChange={(e) => { setItemCategory({ cateDescription: e.target.value }) }} /> */}
                    <TextFields
                        label='Item Category'
                        id='cateDescription'
                        name='cateDescription'
                        value={itemCategory.cateDescription} onChange={onChange} />
                </Grid2>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}>
                    <ButtonNormal text='Add New Category' onClick={onClick} />
                </Grid2>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}>
                    {isLoading && <Loading loadingText='New Added Item' />}
                </Grid2>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}>
                    <StickyHeadTable tableColumns={tableColumns} tableData={categories && categories}
                        onEditClick={onEditClick} onDeleteClick={onDeleteClick} perPage={10} />
                </Grid2>
                <Grid2 size={4}></Grid2>
            </Grid2>
        </>
    )
}